import React from 'react';
import useTranslate from '../../../Hooks/useTranslate';
import { Grid, Divider } from '@mui/material';
import CaptionValue from '../../CaptionValue/CaptionValue';
import { useSetAtom } from 'jotai';
import {
  selectedCustomerIdAtom,
  additionalCustomerDataAtom,
} from '../../../Atoms';
import CallStatusChip from './CallStatusChip';
import { renderColumnValue } from '../../engine/columns/resolveCard';

const EntryComponent = function EntryComponent({
  data,
  columns,
  updateItem,
  currentSection,
  wavePeriod,
  customStatusChipCallback = null,
  rowSxCallback = null,
  disableClickRow = false,
  hideDivider = false,
  customClick = undefined,
  statusSize = { md: 2 },
}) {
  const translate = useTranslate();
  const setSelectedCustomerId = useSetAtom(selectedCustomerIdAtom);
  const setAdditionalCustomerData = useSetAtom(additionalCustomerDataAtom);
  const rowSx = rowSxCallback ? rowSxCallback(data) : {};
  const rowTextColor = rowSx?.color;

  return (
    <>
      <Grid
        id={`${data?.id}-entry`}
        aria-hidden="true"
        container
        spacing={2}
        sx={{
          opacity: data?.removedOn ? 0.5 : 1,
          padding: '16px',
          alignItems: 'center',
          '&:hover': disableClickRow
            ? {}
            : {
                cursor: 'pointer',
                backgroundColor: 'rgba(88, 147, 212, 0.16)',
              },
          ...rowSx,
        }}
        onClick={() => {
          if (disableClickRow) return;
          if (customClick) {
            customClick(data);
            return;
          }
          setSelectedCustomerId(data?.id);
          setAdditionalCustomerData({
            customerName: data?.fullName,
            remainingDays: data?.remainingDays,
            wavePeriod:
              currentSection === 'CUSTOMERS' || currentSection === 'APPOINTMENT'
                ? null
                : wavePeriod,
          });
        }}
      >
        {columns.map((column, index) => (
          <Grid
            key={`${column.id}-${String(index)}-item`}
            id={`${column.id}-${String(index)}-item`}
            size={column.size ?? 'grow'}
          >
            <CaptionValue
              captionColor={rowTextColor || undefined}
              valueColor={rowTextColor || undefined}
              valueStyle={{ fontWeight: 500 }}
              reverse={column.reverse}
              caption={column.noCaption ? '' : column.label}
              value={renderColumnValue(column, data, translate)}
              fallback={column.noCaption ? <div /> : 'UNAVAILABLE'}
            />
          </Grid>
        ))}
        <Grid id="status-grid-item" size={statusSize}>
          {customStatusChipCallback ? (
            customStatusChipCallback({ data, updateItem })
          ) : (
            <CallStatusChip data={data} updateItem={updateItem} />
          )}
        </Grid>
      </Grid>
      {!hideDivider && <Divider />}
    </>
  );
};

export default EntryComponent;
